module.exports = __webpack_public_path__ + "img/2023big24.c8bcc1de.png";